/* Change this file to get your personal Portfolio */

// Summary And Greeting Section

import emoji from 'react-easy-emoji';

const illustration = {
  animated: true, // set to false to use static SVG
};

const greeting = {
  username: 'D.V.A.B. Sarma',
  title: "Hi all, I'm Sarma",
  subTitle: emoji(
    // 'A passionate Cross-Platform Developer 🚀 having an experience of building beautiful applications with Flutter'
    'A passionate AOSP and linux kernel developer with experience in Various Technologies'
  ),
  // resumeLink:
  //   'https://drive.google.com/file/d/17bfbzbqK0VJYpANgr9nO8F7OgI40zYst/view?usp=sharing',
  displayGreeting: true, // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: 'https://github.com/dvab-sarma',
  //linkedin: 'https://www.linkedin.com/in/saadpasta/',
  gmail: 'vdarbha0473@gmail.com',
  reddit:"https://www.reddit.com/user/Head_Lecture_7033/",
  //gitlab: 'https://gitlab.com/saadpasta',
  /*instagram: 'https://www.instagram.com/dvabsarma/',*/
  //medium: 'https://medium.com/@saadpasta',
  // stackoverflow: 'https://stackoverflow.com/users/14906246/d-v-a-b-sarma',
  // Instagram and Twitter are also supported in the links!
  display: true, // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: 'What I do',
  subTitle: 'EXPERIENCED DEVELOPER WHO WANTS TO EXPLORE DIFFERENT TECHNOLOGIES',
  skills: [
      emoji(
      '⚡ Customise linux kernels for various SoCs and develop BSP kernel drivers'
    ),
    emoji(
      '⚡ Develop AOSP 15 & 16 for Rockchip SoC'
    ),
    emoji(
      '⚡ Develop highly interactive Front end / User Interfaces for your applications'
    ),
    /*emoji('⚡ Progressive Mobile Application with beautiful UI & ML integration.'),*/
    emoji(
      '⚡ Integration of third party services such as Firebase / MongoDB '
    ),
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: 'AOSP',
      fontAwesomeClassname: 'fab fa-android',
    },
    {
      skillName: 'Linux Kernel',
      fontAwesomeClassname: 'fab fa-linux',
    },
    {
      skillName: 'C',
      fontAwesomeClassname: 'fab fa-cuttlefish',
    },
    {
      skillName: 'Flutter',
      fontAwesomeClassname: 'fab fa-foursquare',
    },
    {
      skillName: 'Dart',
      fontAwesomeClassname: 'fab fa-dyalog',
    },
    {
      skillName: 'Embedded Systems',
      fontAwesomeClassname: 'fas fa-microchip',
    },
    {
      skillName: 'IOT',
      fontAwesomeClassname: 'fab fa-cloudversify',
    },
        {
      skillName: 'Java',
      fontAwesomeClassname: 'fab fa-java',
    },
   
    
    /*{
      skillName: 'Swift',
      fontAwesomeClassname: 'fab fa-swift',
    },*/
    
   /*{
      skillName: 'MongoDB',
      fontAwesomeClassname: 'fas fa-database',
    },*/
    /*{
      skillName: 'AWS',
      fontAwesomeClassname: 'fab fa-aws',
    },*/
    {
      skillName: 'firebase',
      fontAwesomeClassname: 'fas fa-fire',
    },
    {
      skillName: 'python',
      fontAwesomeClassname: 'fab fa-python',
    },
    {
      skillName: 'JavaScript',
      fontAwesomeClassname: 'fab fa-js',
    },
    {
      skillName: 'React',
      fontAwesomeClassname: 'fab fa-react',
    },
    {
      skillName: 'Data Center Management',
      fontAwesomeClassname: 'fas fa-server',
    },
    
  ],
  display: true, // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
     {
      schoolName: 'Purdue University Northwest',
      schoolName1:'Purdue University Northwest',
      logo: require('./assets/images/Purdue-University-Logo-500x281.png'),
      subHeader: 'M.S in Computer Information Technology',
      duration: 'Jan 2024 - Dec 2025',
      desc:
        '',
      descBullets: [],
    },
    {
      schoolName: 'Aditya Institute of Technology &  Management',
      schoolName1:'Aditya Institute of Technology & Management',
      logo: require('./assets/images/aitam.png'),
      subHeader: 'B.Tech in Electronics & Communications Engineering',
      duration: 'July 2018 - June 2022',
      desc:
        '',
      descBullets: [],
    },
    
    // {
    //   schoolName: 'Ascent Junior College',
    //   logo: require('./assets/images/asset.png'),
    //   subHeader: 'Grade 11 - 12',
    //   duration: 'June 2016 - March 2018',
    //   desc:
    //     '',
    //   descBullets: [],
    // },
    // {
    //   schoolName: 'Vijana Vihara Residential School',
    //   logo: require('./assets/images/school.png'),
    //   subHeader: '10th Grade',
    //   duration: 'June 2015 - March 2016',
    //   desc: 'Participated in conducting various Scientific programs for the School.',
    //   descBullets: [
    //     ,
    //   ],
    // },
    
  ],
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: false, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: 'Linux Kernel Development', //Insert stack or technology you have experience in
      progressPercentage: '80%', //Insert relative proficiency in percentage
    },
    {
      Stack: 'AOSP Development',
      progressPercentage: '75%',
    },
    {
      Stack: 'Programming',
      progressPercentage: '72%',
    },
  ],
  displayCodersrank: false, // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: 'Software Developement Engineer',
      company: 'Virtusa',
      companylogo: require('./assets/images/virtusa.png'),
      date: 'Jan 2022 – Dec 2023',
      desc:'',
        // 'Currently, working as Production Support Engineer ',
      descBullets: [
        
        // 'Resolution of tickets raised by clients within a short time span, providing them an uninteruppted IT service',
        // "Mostly, my work includes (but not limited to) handling servers of various Clientele",
        // "Got my certification from AXELOS in ITIL v4 Foundation",
      ],
    },
    {
      role: 'IOT Engineer Intern',
      company: 'CEMS',
      companylogo: require('./assets/images/cems.png'),
      date: 'May 2021 – June 2021',
      desc:
        'Worked as an intern in various IOT projects ',
    },
    {
      role: 'Flutter Developer Intern',
      company: 'Cogent Web Services',
      companylogo: require('./assets/images/cws.jpeg'),
      date: 'July 2020 – Aug 2020',
      desc:
        'Worked as an Flutter Developer Intern and contributed my skills in various projects which include Ecommerce and Messaging Platforms ',
    },
  ],
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  githubConvertedToken: process.env.REACT_APP_GITHUB_TOKEN,
  githubUserName: 'dvab-sarma', // Change to your github username to view your profile in Contact Section.
  showGithubProfile: 'true', // Set true or false to show Contact profile using Github, defaults to true
  display: true, // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: 'Big Projects',
  subtitle: 'Checkout my latest AOSP developement for Rockchip based SoC',
  projects: [
    // {
    //   image: require('./assets/images/saayaHealthLogo.webp'),
    //   link: 'http://saayahealth.com/',
    // },
        {
      image: require("./assets/images/android_rockchip_1.png"),
      projectName: "Android 15 / 16 Source Code for Rockchip Based SoC",
      projectDesc: "The official Github Repo for AOSP 15 & 16 source code for Rockchip Based SoC",
      footerLink: [
        {
          name: "Visit Github",
          url: "https://github.com/dvab-sarma/android_local_manifest"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/android_rockchip_1.png"),
      projectName: "Android 15 / 16 Pre-Built images for Rockchip Based SoC",
      projectDesc: "Download the latest Pre-built Android burnable images for Rockchip Based SoC",
      footerLink: [
        {
          name: "Visit Google Drive",
          url: "https://drive.google.com/drive/folders/1d5ifTQ6-efLuzAD8wl57woRwLUpaYbc-?usp=sharing"
        }
        //  you can add extra buttons here.
      ]
    },
            {
      image: require("./assets/images/linux_rockchip.png"),
      projectName: "Android Mainline Linux Kernel Source Code for Rockchip Based SoC",
      projectDesc: "The official Github Repo for Android Mainline Kernel source code for Rockchip Based SoC",
      footerLink: [
        {
          name: "Visit Github",
          url: "https://github.com/dvab-sarma/android_kernel_manifest"
        }
        //  you can add extra buttons here.
      ]
    },
  ],
  display: true, // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji('Projects & Certifications 🏆 '),
  subtitle:
    'Projects, Certifications, and Some Cool Stuff that I have done !',

  achievementsCards: [
    {
      title: 'My Projects',
      subtitle:
        'Some Awesome',
      image: require('./assets/images/Git.png'),
      footerLink: [
        {
          name: 'Show Projects',
          url:
            'https://github.com/dvab-sarma',
        },
        
      ],
    },
    {
      title: 'Certifications & Internships',
      subtitle:
        "Certifications I've achieved & Internships I've completed.",
      image: require('./assets/images/certificate.png'),
      footerLink: [
        {
          name: 'Show Certificates',
          url:
            'https://drive.google.com/drive/folders/1A2kpM5bMDSWvCUKEvyNUgVImXEf3-A_W?usp=sharing',
        },
      ],
    },

    
  ],
  display: false, // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: 'Blogs',
  subtitle:
    'With Love for Developing cool stuff, I love to write and teach others what I have learnt.',

  blogs: [
    {
      url:
        'https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae',
      title: 'Win a Google Assistant Tshirt and $200 in Google Cloud Credits',
      description:
        'Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?',
    },
    {
      url: 'https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e',
      title: 'Why REACT is The Best?',
      description:
        'React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies.',
    },
  ],
  display: true, // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: 'TALKS',
  subtitle: emoji(
    'I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅'
  ),

  talks: [
    {
      title: 'Build Actions For Google Assistant',
      subtitle: 'Codelab at GDG DevFest Karachi 2019',
      slides_url: 'https://bit.ly/saadpasta-slides',
      event_url: 'https://www.facebook.com/events/2339906106275053/',
    },
  ],
  display: true, // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji('Podcast 🎙️'),
  subtitle: 'I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY',

  // Please Provide with Your Podcast embeded Link
  podcast: [
    'https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo',
  ],
  display: true, // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji('Contact Me ☎️'),
  subtitle:
    'Discuss a project or just want to say hi? My Inbox is open for all.',
  number1: '+1-219-466-8886',
  
  
  emailAddress: 'vdarbha0473@gmail.com',
};

// Twitter Section

const twitterDetails = {
  userName: 'twitter', //Replace "twitter" with your twitter username without @
  display: false, // Set true to display this section, defaults to false
};

export {
  illustration,
  greeting,
  socialMediaLinks,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
};
